import React from 'react'
import { Checkbox, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

const RenderFilterOption = (props, option, { selected }) => {
  const { value } = option

  return (
    <ListItemButton dense disableGutters {...props}>
      <ListItemIcon sx={{ minWidth: 0 }}>
        <Checkbox checked={selected} />
      </ListItemIcon>
      <ListItemText
        primary={value}
        slotProps={{
          primary: { variant: 'body1', fontWeight: 400 },
        }}
      />
    </ListItemButton>
  )
}

RenderFilterOption.propTypes = {}

export default RenderFilterOption
